export enum EventPrinterStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

export enum EventStatusEnum {
  Archived = 'ARCHIVED',
  Active = 'ACTIVE',
}

export enum EventAiModelType {
  Nike = 'NIKE',
  StableDiffusion = 'STABLE_DIFFUSION',
}

export enum EventModelPosition {
  Front = 'FRONT',
  Back = 'BACK',
  Both = 'BOTH',
}

export enum EventParticipantStatus {
  Unconfirmed = 'UNCONFIRMED',
  Confirmed = 'CONFIRMED',
  CheckedIn = 'CHECKED_IN',
}

export enum EventTabsType {
  Models = 'models',
  Styles = 'styles',
  Masks = 'masks',
  Printers = 'printers',
  Inventory = 'inventory',
  Participants = 'participants',
}

export const eventStatusOptions = [
  { value: EventStatusEnum.Active.toLowerCase(), id: EventStatusEnum.Active },
  {
    value: EventStatusEnum.Archived.toLowerCase(),
    id: EventStatusEnum.Archived,
  },
];

export const positionOptions = [
  {
    value: EventModelPosition.Front.toLowerCase(),
    id: EventModelPosition.Front,
  },
  { value: EventModelPosition.Back.toLowerCase(), id: EventModelPosition.Back },
  { value: 'Back and Front', id: EventModelPosition.Both },
];

export const participantStatusOptions = [
  {
    value: EventParticipantStatus.Unconfirmed.toLowerCase(),
    id: EventParticipantStatus.Unconfirmed,
  },
  {
    value: EventParticipantStatus.Confirmed.toLowerCase(),
    id: EventParticipantStatus.Confirmed,
  },
  {
    value: EventParticipantStatus.CheckedIn.toLowerCase(),
    id: EventParticipantStatus.CheckedIn,
  },
];

export const eventAiOptions = [
  { value: 'Nike', id: EventAiModelType.Nike },
  {
    value: 'Stable Diffusion',
    id: EventAiModelType.StableDiffusion,
  },
];

export enum InventoryReportType {
  CheckedOutBags = 'bags-checked-out',
  BackStockInventory = 'current-stock',
}

export const maxVideoPreviewSize = 100 * 1024 * 1024;
